<template>
  <div id="app">
    <commonhead :active_menu="-1" :callback="authcallback" />
    <div class="user_course_comment my_style">
      <div class="content_wrap">
        <p class="flag">
          <span class="name">
            <router-link to="/user-center-info">个人中心</router-link>
          </span>
          <span class="next">></span>
          <span class="name">
            <router-link to="/user/course">我的课程</router-link>
          </span>
          <span class="next">></span>
          <span class="name">评价</span>
        </p>
        <!--课程信息-->
        <p class="current_title">评价订单</p>
        <!-- <p class="order_num">订单号：{{resData[0].order.order_id}}</p> -->
        <div class="course_info">
          <div class="content" v-for="(item,index) in resData" :key="index">
            <span class="left_img">
              <img :src="item.teacher.avatar" alt="教师头像" class="pic_full" />
            </span>
            <div class="right_info">
              <div class="item">
                <span class="key">教师姓名</span>
                <span class="value">{{item.teacher.real_name}}</span>
              </div>
              <div class="item">
                <span class="key">上课时间</span>
                <span class="value">{{getLocalTime(item.start)}}</span>
              </div>
              <div class="item dif">
                <span class="key">付款方式</span>
                <span class="value">{{payment[item.order.payment_method]}}</span>
              </div>
            </div>
            <div class="comment_area" v-if="!comment_finish">
              <div class="star">
                <div class="titlebox">
                  <span class="must">*</span>
                  <span class="text">评分</span>
                </div>
                <div class="star_area">
                  <span class="star_item" v-if="star > 0" @click="change_star(1)">
                    <img src="../../assets/image/comment/star.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star > 1" @click="change_star(2)">
                    <img src="../../assets/image/comment/star.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star < 2" @click="change_star(2)">
                    <img src="../../assets/image/comment/unstar.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star > 2" @click="change_star(3)">
                    <img src="../../assets/image/comment/star.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star < 3" @click="change_star(3)">
                    <img src="../../assets/image/comment/unstar.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star > 3" @click="change_star(4)">
                    <img src="../../assets/image/comment/star.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star < 4" @click="change_star(4)">
                    <img src="../../assets/image/comment/unstar.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star > 4" @click="change_star(5)">
                    <img src="../../assets/image/comment/star.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star < 5" @click="change_star(5)">
                    <img src="../../assets/image/comment/unstar.png" alt class="pic_full" />
                  </span>
                </div>
                <span class="text_star">{{star}}星</span>
              </div>
              <div class="teacher_tags">
                <div class="titlebox">
                  <div class="tag_title">标签</div>
                </div>
                <div class="tagbox">
                    <div class="tag-item" :class="tag[0].active?'tag-item_active':''" @click="selecttag(0)">
                      <div class="icon-tag icon-tag1"></div>
                      <div class="tag-text">有趣的</div>
                    </div>
                    <div class="tag-item" :class="tag[1].active?'tag-item_active':''" @click="selecttag(1)">
                      <div class="icon-tag icon-tag2"></div>
                      <div class="tag-text">激励大师</div>
                    </div>
                    <div class="tag-item" :class="tag[2].active?'tag-item_active':''" @click="selecttag(2)">
                      <div class="icon-tag icon-tag3"></div>
                      <div class="tag-text">擅长会话</div>
                    </div>
                    <div class="tag-item" :class="tag[3].active?'tag-item_active':''" @click="selecttag(3)">
                      <div class="icon-tag icon-tag4"></div>
                      <div class="tag-text">擅长教孩子</div>
                    </div>
                    <div class="tag-item" :class="tag[4].active?'tag-item_active':''" @click="selecttag(4)">
                      <div class="icon-tag icon-tag5"></div>
                      <div class="tag-text">超出预期</div>
                    </div>
                    <div class="tag-item" :class="tag[5].active?'tag-item_active':''" @click="selecttag(5)">
                      <div class="icon-tag icon-tag6"></div>
                      <div class="tag-text">文化视角</div>
                    </div>
                  </div>
              </div>
              <div class="comment_input">
                <div class="titlebox">
                  <span class="title">评价内容</span>
                </div>
                <textarea
                  name
                  id
                  cols="30"
                  rows="10"
                  placeholder="请输入您的评价"
                  v-model="comment_summary"
                ></textarea>
              </div>
            </div>
            <!--评价完成-->
            <div class="comment_area success" v-if="comment_finish">
              
              <div class="star">
                <div class="titlebox">
                  <span class="text">评分</span>
                </div>
                <div class="star_area">
                  <span class="star_item" v-if="star > 0">
                    <img src="../../assets/image/comment/star.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star > 1">
                    <img src="../../assets/image/comment/star.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star < 2">
                    <img src="../../assets/image/comment/unstar.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star > 2">
                    <img src="../../assets/image/comment/star.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star < 3">
                    <img src="../../assets/image/comment/unstar.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star > 3">
                    <img src="../../assets/image/comment/star.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star < 4">
                    <img src="../../assets/image/comment/unstar.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star > 4">
                    <img src="../../assets/image/comment/star.png" alt class="pic_full" />
                  </span>
                  <span class="star_item" v-if="star < 5">
                    <img src="../../assets/image/comment/unstar.png" alt class="pic_full" />
                  </span>
                </div>
              </div>
              <div class="teacher_tags">
                <div class="titlebox">
                  <div class="tag_title">标签</div>
                </div>
                <div class="tagbox">
                    
                    <div class="tag-item tag-item_active" v-for="(item,index) in tags" :key="index">
                      <div class="icon-tag icon-tag1"></div>
                      <div class="tag-text">{{item}}</div>
                    </div>
                    <!-- <div class="tag-item">
                      <div class="icon-tag icon-tag2"></div>
                      <div class="tag-text">激励大师</div>
                    </div>
                    <div class="tag-item">
                      <div class="icon-tag icon-tag3"></div>
                      <div class="tag-text">擅长会话</div>
                    </div>
                    <div class="tag-item">
                      <div class="icon-tag icon-tag4"></div>
                      <div class="tag-text">擅长教孩子</div>
                    </div>
                    <div class="tag-item">
                      <div class="icon-tag icon-tag5"></div>
                      <div class="tag-text">超出预期</div>
                    </div>
                    <div class="tag-item">
                      <div class="icon-tag icon-tag6"></div>
                      <div class="tag-text">文化视角</div>
                    </div> -->
                  </div>
              </div>
              <div class="comment_input">
                <div class="titlebox">
                  <span class="title">评价内容</span>
                </div>
                <span class="comment_show">{{comment_summary}}</span>
              </div>
              <p class="success_title">感谢评价完成</p>
              <!-- <button class="reward hand_point">打赏</button>
              <button class="back_course hand_point" @click="back">返回课程详情</button>
              <button class="back_course hand_point">
                <router-link to="/user-center-info">返回个人中心</router-link> 
              </button> -->
            </div>
          </div>
        </div>
        <div class="comment_actions" v-if="!comment_finish">
          <button class="back_btn hand_point" @click="back">返回</button>
          <button class="submit hand_point" @click="submit(resData[0].course_id)"><i class="el-icon-loading" v-if="!cansubmit"></i>提交</button>
        </div>
        <div class="reward_info" v-if="comment_finish">
          <div class="reward_title">{{pay_finish?('感谢打赏'+amount+'学贝'):'请选择礼品打赏该老师'}}</div>
          <div class="reward_subtitle">愿每一份付出都能被温柔以待</div>
          <div class="reward_items" v-if="!pay_finish">
            <div class="reward_item" :class="amount==15?'reward_item_active':''" @click="changeamount(15)">
              <div class="icon-rw1"></div>
              <div class="reward_text">15学贝</div>
            </div>
            <div class="reward_item" :class="amount==5?'reward_item_active':''" @click="changeamount(5)">
              <div class="icon-rw2"></div>
              <div class="reward_text">5学贝</div>
            </div>
          </div>
        </div>
        <div class="buttons" v-if="comment_finish && !pay_finish">
          <button class="button back_page" @click="back">返回</button>
          <button class=" button reward_pay" @click="paybonus"><i class="el-icon-loading" v-if="paying"></i>打赏</button>  
        </div>
      </div>
      <div class="bottombox">
        <commonbottom />
      </div>
      <!--公共底部-->
      <commonfoot />
      <!--公共底部-->
    </div>
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import commonbottom from '../common/common_bottom';
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    commonbottom
  },
  data: function() {
    return {
      star: 5,
      comment_summary: "",
      resData: "",
      comment_finish: false, //是否评价完成
      paying: false,
      payment: {
        '0': '学贝',
        '1': '支付宝',
        '2': '微信',
        '4': '体验课'
      },
      amount: 15,
      tag: {
        '0': {
          text: '有趣的',
          active: false
        },
        '1': {
          text: '激励大师',
          active: false
        },
        '2': {
          text: '擅长会话',
          active: false
        },
        '3': {
          text: '擅长教孩子',
          active: false
        },
        '4': {
          text: '超出预期',
          active: false
        },
        '5': {
          text: '文化视角',
          active: false
        }
      },
      cansubmit: true,
      pay_finish: false,
      tags:[]
    };
  },
  mounted: function() {
    if (this.$route.query.id) {
      this.getList(this.$route.query.id);
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    change_star(num) {
      this.star = num;
    },
    submit(course_id) {
      if(!this.cansubmit){
        return;
      }
      this.cansubmit = false;
      let self = this;
      let tags=[];
      for (let i = 0; i < 6; i++) {
        if(self.tag[i].active){
          tags.push(self.tag[i].text)
        }  
      }
      
      common.requestFun(
        self,
        "post",
        "/student/course/done/comment",
        {
          comment: self.comment_summary,
          course_id: course_id,
          rate: self.star,
          tags: tags
        },
        res => {
          if (res.data.code == 200) {
            self.comment_finish = true;
            self.tags = tags;
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
          self.cansubmit = true;
        },
        ()=>{
          self.cansubmit = true;
        }
      );
    },
    getList(id) {
      let self = this;
      common.requestFun(
        self,
        "get",
        "/student/courses",
        {
          reservation_id: self.$route.query.id
        },
        res => {
          if (res.data.code == 200) {
            self.resData = res.data.data.list;
            self.comment_finish = (self.resData[0].status == 5)?true:false;
            if(self.comment_finish){
              var comment = self.resData[0].comment;
              if(comment){
                self.comment_summary = comment.content?comment.content:'';
                self.star = comment.rate;
                if(comment.tags){
                  comment.tags.forEach(item => {
                    self.tags.push(item.tag);
                  });
                }
              }
              if(self.resData[0].course.bonus){
                self.pay_finish = true;
                self.amount = self.resData[0].course.bonus.coin_amount;
              }
            }
            

          }
        }
      );
    },
    getLocalTime(nS) {
      var coursedate = new Date(parseInt(nS) * 1000);
      var year = coursedate.getFullYear();
      var month = coursedate.getMonth()+1;
      var date = coursedate.getDate();

      return year+'-'+(month<10?('0'+month):month)+'-'+(date<10?('0'+date):date)
    },
    paybonus: function(){
      if(this.paying){
        return;
      }
      this.paying = true;
      let self = this;
      common.requestFun(
        self,
        "post",
        "/student/bonus",
        {
          teacher_id: self.resData[0].teacher_id,
          amount: self.amount,
          payment_method: 0,
          course_id: self.resData[0].course_id
        },
        res => {
          if (res.data.code == 200) {
            // self.pay_finish = true;
            // 支付
            common.requestFun(
              self,
              "post",
              "/payment/coin",
              res.data.data,
              payres => {
                if (payres.data.code == 200) {
                  self.pay_finish = true;
                  // 支付
                  
                } else {
                  if (payres.data.msg) {
                    self.$message({
                      message: payres.data.msg,
                      type: "error",
                      center: true
                    });
                    self.paying = false;
                  }
                }
                
              },
              ()=>{
                self.paying = false;
              }
            );
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
              self.paying = false;
            }
          }
          
        },
        ()=>{
          self.paying = false;
        }
      );
    },
    selecttag(index){
      this.tag[index].active = !this.tag[index].active;
    },
    changeamount(num){
      this.amount!=num&&(this.amount = num);
    },
    authcallback(isLogin){
      if(!isLogin){
          this.$message({
              message: "请登录",
              type: "error",
              center: true
          });
          this.$router.push("./");
      }
    }
  }
};
</script>
<style scoped src="./user_course_comment.css"></style>
